import React, {useState, useEffect} from 'react';

import "antd/dist/antd.min.css";
import './App.scss';

import { PROJECT_ID, CONTEXT, URL } from './config';
import LoginModal from "./pages/LoginPage";
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import AppRoutes from './components/AppRoutes';
import ErrorCard from './components/ErrorCard';
import LoginCard from './components/LoginCard';

import { getSSOUser } from "./services/authService";
import { MenuProvider } from './contexts/menu';
import { SnackBarProvider } from './contexts/snackbar';
import { KPIProvider } from './contexts/kpi';
import Loader from './utilities/Loader';
import { useTheme } from "./hooks";
import Utils from './utilities';
import { CONTEXT_NAME } from './config'
import AccessCard from './components/AccessCard';


function App() {
  const { isDarkMode } = useTheme();
  const [isLoading, setIsLoading] = useState(true);
  const [loggedIn, setLogin] = useState(false);
  const [loginData, setLoginData] = useState(null);
  const [domain, setDomain] = useState("");
  const [errors, setErrors] = useState([]);
  const [SSOType, setSSOType] = useState("SSO"); 
  const [contextLogged, setContextLogged] = useState(URL);

  const setDocumentTitle = () => {
    let title = CONTEXT_NAME ? `${CONTEXT_NAME} - ` : "";
    document.title = `${title}Incedo Lighthouse`;
  }

  const resetLoggedIn = () => {
    Utils.setStoredValue("resp", "");
    setDomain("");
    setLogin(false);
    setLoginData(null);
    
    if(loggedIn){ window.location = URL }
  };

  const setLoggedIn = (response) => {
    Utils.setStoredValue("resp", { isLogged: contextLogged, response });
    setDomain(PROJECT_ID);
    setLogin(true);
    setLoginData(response);
  };

  const handleSSO = () => {
    if(SSOType !== "SSO"){ return; }
    setErrors([]);
    getSSOUser().then(response => {
      if(response.status === 200){
        
        (`loginType` in response.data)
          ? setSSOType(response.data.loginType)
          : setSSOType('');

        Utils.setStoredValue('version', response.data.version);

        if(response.data.loginType === "SSO"){
          setLoggedIn(response.data);
          if (PROJECT_ID) { setDomain(PROJECT_ID); }
        }

      }else{
        setErrors([response.data.message]);
      }
    }).catch(_error => {
        setErrors(["Error in Loading Lighthouse Application"]);
    }).finally(() => {
        setIsLoading(false);
    });
  };

  const setLoggedInData = () => {
    const lsData = Utils.getStoredValue('resp');
    if(lsData && `response` in lsData){
      setLoginData(lsData.response);
      setLogin(lsData.isLogged === contextLogged ? true : false);
      setDomain(lsData.isLogged === contextLogged ? PROJECT_ID : "");
      setIsLoading(false);
    }
  }
  
  useEffect(() => {
    setDocumentTitle();
    setLoggedInData();
    handleSSO();
    
  }, []);

  if(loggedIn === false || domain < 0){
    if(errors.length){ return <ErrorCard title={`Contact Technical Team`} detail={`Error in loading Lighthouse application`} />}
    return isLoading
      ? <div className="text-center mt-5"><Loader /></div>
      : <LoginModal
        loggedIn={loggedIn}
        setLoggedIn={setLoggedIn}
        resetLoggedIn={resetLoggedIn}
        setDomain={setDomain}
      />
  }

  return (
    <div className={isDarkMode ? 'theme-dark' : 'theme-default'}>
      <Header loginData={loginData} resetLoggedIn={resetLoggedIn} />
      <div className="flyout">
        <MenuProvider>
          <Sidebar />
          <KPIProvider>
          <SnackBarProvider>
            <main className="main-content"><AppRoutes /></main>
          </SnackBarProvider>
          </KPIProvider>
        </MenuProvider>
      </div>
      <LoginCard loginData={loginData} resetLoggedIn={resetLoggedIn} contextLogged={contextLogged} />
      <AccessCard />
    </div>
  );
}

export default App;
